// import Swiper JS
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
// import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
const breakpoints = {
  768: { slidesPerView: 2.5, spaceBetween: 30 },
  1024: { slidesPerView: 3.5, spaceBetween: 30 },
};
const breakpoints2 = {
  0: { slidesPerView: 2, spaceBetween: 30 },
  400: { slidesPerView: 2, spaceBetween: 30 },
  768: { slidesPerView: 3.25, spaceBetween: 30 },
};
document.addEventListener("DOMContentLoaded", () => {
  const images = new Swiper(".slider-images", {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    direction: "horizontal",
    keyboard: true,
    pagination: {
      el: ".pagination-images",
      clickable: true,
    },
    navigation: {
      nextEl: ".images-next",
      prevEl: ".images-prev",
    },
  });

  function updateProgressBar(swiper) {
    const progressEl = document.querySelector(
      ".pagination-testimonials-progress"
    );
    if (progressEl) {
      let slidesPerView = swiper.slidesPerViewDynamic();
      if (!slidesPerView || isNaN(slidesPerView)) {
        slidesPerView = swiper.params.slidesPerView;
        if (typeof slidesPerView === "object") {
          const breakpoint = swiper.currentBreakpoint;
          slidesPerView =
            slidesPerView[breakpoint] || swiper.originalParams.slidesPerView;
        }
      }

      const totalSlides = swiper.slides.length;
      const steps = Math.max(Math.ceil(totalSlides / slidesPerView), 1);
      const baseProgress = 100 / steps;
      const progress = baseProgress * swiper.activeIndex;
      progressEl.style.width = `${Math.min(progress + baseProgress, 100)}%`;
    }
  }

  const testimonials = new Swiper(".slider-testimonials", {
    modules: [Pagination, Navigation],
    direction: "horizontal",
    slidesPerView: 1.25,
    spaceBetween: 16,
    breakpoints,
    keyboard: true,
    // pagination: {
    //   el: ".pagination-testimonials",
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".testimonials-next",
      prevEl: ".testimonials-prev",
    },
    on: {
      init: function () {
        setTimeout(() => {
          this.update();
          updateProgressBar(this);
        }, 1000);
      },
      slideChange: function () {
        updateProgressBar(this);
      },
    },
  });
});
const testimonialsStaggered = new Swiper(".slider-testimonials-staggered", {
  modules: [Navigation],
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 40,
  keyboard: true,
  navigation: {
    nextEl: ".staggered-next",
    prevEl: ".staggered-prev",
  },
});

const adjustedBreakpoints2 = { ...breakpoints2 };
if (window.innerHeight < 750) {
  adjustedBreakpoints2[0] = { slidesPerView: 1, spaceBetween: 30 };
}

const isMobile = window.innerWidth < 768;

const overOns = new Swiper(".slider-overOns", {
  modules: [Navigation],
  direction: "vertical",
  centeredSlides: true,
  initialSlide: 2,
  keyboard: true,
  loop: true,
  allowTouchMove: !isMobile,
  breakpoints: adjustedBreakpoints2,
  navigation: {
    nextEl: ".overons-next",
    prevEl: ".overons-prev",
  },
  on: {
    beforeInit: function () {
      const slideCount = document.querySelectorAll(
        ".slider-overOns .swiper-slide"
      ).length;
      this.params.loopedSlides = slideCount * 2;
    },
  },
});
